module.exports = __webpack_public_path__ + "img/banner.faa0b8bc.jpeg";